import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-64cbbf0a")

_pushScopeId("data-v-64cbbf0a")
const _hoisted_1 = {
  style: {"width":"31rem"},
  class: "relative overflow-y-auto"
}
const _hoisted_2 = { class: "p-field-radiobutton gap-x-3 pt-3 flex flex-row lp-radio" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", { for: "active-client-status" }, "Unfreeze", -1)
const _hoisted_4 = { class: "p-field-radiobutton gap-x-3 pt-3 flex flex-row lp-radio" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { for: "freeze-client-status" }, "Freeze", -1)
const _hoisted_6 = { class: "bg-gray-lp-200 p-3 rounded-md mt-6" }
const _hoisted_7 = { class: "flex items-start gap-x-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px font-normal text-gray-lp-800" }, " Akun yang dibekukan tidak dapat melakukan aktivitas apapun sampai akun diaktifkan kembali. Anda dapat mengubah status kapan saja. ", -1)
const _hoisted_9 = { class: "flex justify-end mt-16" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return _withDirectives((_openBlock(), _createBlock(_component_Dialog, {
    "model-value": _ctx.modelValue,
    persistent: true,
    title: "Ubah Status Client",
    "onUpdate:modelValue": _ctx.togglePopup
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_RadioButton, {
            id: "active-client-status",
            name: "status-client",
            value: "active",
            modelValue: _ctx.statusClient,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.statusClient = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeStatus('active')))
          }, null, 8, ["modelValue"]),
          _hoisted_3
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_RadioButton, {
            id: "freeze-client-status",
            name: "status-client",
            value: "freeze",
            modelValue: _ctx.statusClient,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.statusClient = $event)),
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeStatus('freeze')))
          }, null, 8, ["modelValue"]),
          _hoisted_5
        ]),
        _createVNode(_component_DataWrapper, { class: "pt-1" }, {
          default: _withId(() => [
            _createVNode(_component_lp_input, {
              disabled: _ctx.statusClient === 'active',
              "disable-background": true,
              modelValue: _ctx.freezeReason,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.freezeReason = $event)),
              placeholder: "Masukan alasan pembekuan"
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("img", {
              src: require(`@/app/ui/assets/svg/info-red.svg`),
              class: "ml-2 w-5",
              alt: "info"
            }, null, 8, ["src"]),
            _hoisted_8
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_lp_button, {
            disabled: !_ctx.isFormValid,
            "text-color": "white",
            "custom-class": "px-10",
            title: "Simpan",
            onClick: _ctx.confirmationChangeStatus
          }, null, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"])), [
    [_vShow, _ctx.showingDialog]
  ])
})